import React from 'react';
import { I18n } from '@aws-amplify/core';
import * as S from './styles';

export function BorgScaleTable(): JSX.Element {
	const options = [
		{ value: '0', description: I18n.get('No effort') },
		{ value: '0,5', description: I18n.get('Very low effort, barely perceptible') },
		{ value: '1', description: I18n.get('Very weak effort') },
		{ value: '2', description: I18n.get('Weak / light effort') },
		{ value: '3', description: I18n.get('Moderate / regular effort') },
		{ value: '4', description: I18n.get('Somewhat strong effort') },
		{ value: I18n.get('5 and 6'), description: I18n.get('Strong effort') },
		{ value: I18n.get('7, 8 and 9'), description: I18n.get('Very strong effort') },
		{ value: '10', description: I18n.get('Extremely strong effort') }
	];

	return (
		<S.Container>
			<S.Title>{I18n.get('Borg Scale')}</S.Title>
			<S.BorgScaleTable>
				<tbody>
					{options.map((item, index) => (
						<S.TableRow key={index}>
							<S.TableCell>{item.value}</S.TableCell>
							<S.TableCell>{item.description}</S.TableCell>
						</S.TableRow>
					))}
				</tbody>
			</S.BorgScaleTable>
		</S.Container>
	);
}
